import React, { useEffect, useState } from 'react';
import Bet from './Bet';
import Filters from './Filters';
import { db } from '../firebase';
import { collection, getDocs, query, where, updateDoc, doc, arrayUnion, arrayRemove, getDoc } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import { sendNotification } from '../database/Functions';
import { v4 as uuidv4 } from 'uuid';
import { FaEllipsis, FaMagnifyingGlass } from 'react-icons/fa6';

function FriendsList() {
    const [friendProfiles, setFriendProfiles] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const { currentUser, userProfile } = useAuth();

    useEffect(() => {
        fetchFriendsProfiles(userProfile.friends);
      }, [currentUser, userProfile.friends]);

    const handleSearch = async (searchParam) => {
        if (!searchParam || searchParam === "") {
          // Reset search if query is empty
          fetchFriendsProfiles(userProfile.friends);
          return;
        }
    
        try {
          /* const q = query(
            collection(db, "users"),
            where("full_name", "==", searchParam) // Adjust for email search
          );
          const querySnapshot = await getDocs(q);
          const result = querySnapshot.docs.map(doc => doc.data()); */

          const usersCollection = collection(db, "users");
    
          // Fetch all documents (you can limit results if necessary)
          const querySnapshot = await getDocs(usersCollection);

          // Convert searchParam to lowercase for case-insensitive comparison
          const lowercasedSearch = searchParam.toLowerCase();

          // Filter results locally
          const result = querySnapshot.docs
            .map((doc) => doc.data())
            .filter((user) => {
              const fullName = user.full_name || "";
              const username = user.username || "";
              const email = user.email || "";

              return (
                fullName.toLowerCase().includes(lowercasedSearch) ||
                username.toLowerCase().includes(lowercasedSearch) ||
                email.toLowerCase().includes(lowercasedSearch)
              );
            });

          if(result.length){
            var friendData = result[0];
            var friendRequestStatus = await fetchFriendRequestStatus(friendData)
            friendRequestStatus.requestedMe = friendRequestStatus.requestedMe;
            friendRequestStatus.alreadyRequested = friendRequestStatus.alreadyRequested;
            result[0].requestedMe = friendRequestStatus.requestedMe;
            result[0].alreadyRequested = friendRequestStatus.alreadyRequested;
          }

          setFriendProfiles(result);

        } catch (error) {
          console.error('Error performing search:', error);
        }
      };

      const fetchFriendsProfiles = async (friends) => {
        if (currentUser) {
          try {
            const finalResults = [];
            const tmpFriendProfiles = [];
            
            for (const friendEmail of friends) {
              if (friendEmail === userProfile.email) continue;
    
              const q = query(collection(db, "users"), where("email", "==", friendEmail));
              const querySnapshot = await getDocs(q);
              for (const doc of querySnapshot.docs) {
                const friendData = doc.data();
                friendData.id = doc.id;
                var friendRequestStatus = await fetchFriendRequestStatus(friendData)
                friendRequestStatus.requestedMe = friendRequestStatus.requestedMe;
                friendRequestStatus.alreadyRequested = friendRequestStatus.alreadyRequested;
                friendData.requestedMe = friendRequestStatus.requestedMe;
                friendData.alreadyRequested = friendRequestStatus.alreadyRequested;
                tmpFriendProfiles.push(friendData);
              }
            }
            finalResults.sort((a, b) => new Date(a.bet_time) - new Date(b.bet_time));
            setFriendProfiles(tmpFriendProfiles);    
          } catch (error) {
            console.error('Error fetching bets:', error);
          }
        }
      };

      const fetchFriendRequestStatus = async (friend) => {
        var alreadyRequested = false;
        var requestedMe = false;

        var friendStatus = {alreadyRequested, requestedMe}

        try {
          const notificationsRef = collection(db, 'Notifications');
          const q = query(
            notificationsRef,
            where('fromUid', '==', currentUser.uid),
            where('type', '==', 'Request'),
            where('toUid', '==', friend.id),
          );
      
          const querySnapshot = await getDocs(q);
      
          const notifications = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

          if(notifications.length){
            alreadyRequested = true;
          }
          const notificationsRef2 = collection(db, 'Notifications');
          const q2 = query(
            notificationsRef2,
            where('toUid', '==', currentUser.uid),
            where('type', '==', 'Request'),
            where('fromUid', '==', friend.id),
          );
      
          const querySnapshot2 = await getDocs(q2);
      
          const notifications2 = querySnapshot2.docs.map(doc => ({ id: doc.id, ...doc.data() }));

          if(notifications2.length){
            requestedMe = true;
          }

          friendStatus.alreadyRequested = alreadyRequested;
          friendStatus.requestedMe = requestedMe;

        } catch (error) {
          console.error('Error fetching notifications:', error);
          return [];
        }

        return friendStatus;
      }

      const handleDeleteFriend = async (friendEmail) => {
        try {
          // References to the current user and friend's documents
          const currentUserRef = doc(db, 'users', currentUser.uid);
          const friendRef = query(collection(db, 'users'), where('email', '==', friendEmail));
          const friendSnapshot = await getDocs(friendRef);
      
          if (!friendSnapshot.empty) {
            const friendDoc = friendSnapshot.docs[0]; // Assuming unique emails
            const friendDocRef = doc(db, 'users', friendDoc.id);
      
            // Remove friend from the current user's friends list
            await updateDoc(currentUserRef, {
              friends: arrayRemove(friendEmail),
            });
      
            // Remove current user from the friend's friends list
            await updateDoc(friendDocRef, {
              friends: arrayRemove(currentUser.email),
            });
      
            console.log(`Friendship with ${friendEmail} has been successfully deleted.`);
          } else {
            console.error('Friend not found.');
          }
        } catch (error) {
          console.error('Error deleting friend:', error);
        }
        setSearchQuery("");
        setFriendProfiles([]);
        fetchFriendsProfiles(userProfile.friends)
      };
      
    
      const handleFriendAction = async (friend) => {
        const isFriend = userProfile.friends.includes(friend.email);
        var alreadyRequested = false;
        var requestedMe = false;

        try {
          const notificationsRef = collection(db, 'Notifications');
          const q = query(
            notificationsRef,
            where('fromUid', '==', currentUser.uid),
            where('type', '==', 'Request'),
            where('toUid', '==', friend.id),
          );
      
          const querySnapshot = await getDocs(q);
      
          const notifications = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

          if(notifications.length){
            alreadyRequested = true;
          }

          const notificationsRef2 = collection(db, 'Notifications');
          const q2 = query(
            notificationsRef2,
            where('toUid', '==', currentUser.uid),
            where('type', '==', 'Request'),
            where('fromUid', '==', friend.id),
          );
      
          const querySnapshot2 = await getDocs(q2);
      
          const notifications2 = querySnapshot2.docs.map(doc => ({ id: doc.id, ...doc.data() }));

          if(notifications2.length){
            requestedMe = true;
          }
        } catch (error) {
          console.error('Error fetching notifications:', error);
          return [];
        }

        if (isFriend) {
          handleDeleteFriend(friend.email)
          alert("Removed Friend!");
        }else if(requestedMe){
          console.log("friend prof are ",friendProfiles)
          var friend = friendProfiles[0];

          const fromUserRef = doc(db, 'users', friend.id);
          const fromUserSnapshot = await getDoc(fromUserRef);
      
          if (!fromUserSnapshot.exists()) {
            console.error('User not found.');
            return;
          }
      
          const fromUserData = fromUserSnapshot.data();
      
          // Add the users as friends to each other
          const currentUserRef = doc(db, 'users', currentUser.uid);
          
          // Add the "from" user to the current user's friends list
          await updateDoc(currentUserRef, {
            friends: arrayUnion(fromUserData.email), // Use the current user's email
          });
      
          // Add the current user to the "from" user's friends list
          await updateDoc(fromUserRef, {
            friends: arrayUnion(currentUser.email),
          });
          
          alert(`Added Friend}` );
          setSearchQuery("");
          setFriendProfiles([]);
          fetchFriendsProfiles()
        } else if(alreadyRequested){
          alert("You already sent them a friend request");
        }
        else {
          try {
            // Fetch the friend's UID based on email
            const q = query(collection(db, "users"), where("email", "==", friend.email));
            const querySnapshot = await getDocs(q);
            if (!querySnapshot.empty) {
              const friendDoc = querySnapshot.docs[0];
              const friendUid = friendDoc.id; // Use the document ID as UID
    
              const key = uuidv4();
    
    
              // Send notification
              await sendNotification(
                "Request",
                userProfile.full_name,
                currentUser.uid,
                friendUid, // Pass the friend's UID
                "sent you a friend request",
                "FriendsBets",
                userProfile.profile_picture
              );
      
              // Add friend, //setFriendProfiles([...friendProfiles, friend]); */
            
              alert("Sent a friend request.");
              setSearchQuery("");
              setFriendProfiles([]);
              fetchFriendsProfiles()
            } else {
              console.error('Friend not found');
              setSearchQuery("");
              setFriendProfiles([]);
              fetchFriendsProfiles()
            }
          } catch (error) {
            console.error('Error adding friend:', error);
            setSearchQuery("");
            setFriendProfiles([]);
            fetchFriendsProfiles()
          }
        }
        setSearchQuery("");
        setFriendProfiles([]);
        fetchFriendsProfiles(userProfile.friends)
      };

  return (
    <div className=" lg:block w-full p-4rounded-md mt-5">

        <div className='w-full items-center flex p-2 mb-4 rounded-full border bg-gradient-to-b from-gray-900 to-black text-white'>
            <span className='px-3 border-none'><FaMagnifyingGlass size={12} color="white"/></span>
            <input
                type="text"
                placeholder="Search Friends"
                className=" bg-gradient-to-b from-gray-900 to-black w-full "
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyUp={() => handleSearch(searchQuery)}
            />
        </div>
          <h2 className="text-white text-2xl mb-4 font-bold">Friends</h2>
          
          <div className="space-y-4 w-full">
            {friendProfiles.map((friend, index) => (
              <div key={index} className="  flex items-center justify-between space-x-4 hover:bg-gray-700 p-2 rounded-md">
                <div className="flex items-center space-x-4">
                <img
                    src={friend.profile_picture || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'}
                    alt={friend.email}
                    className="w-12 h-12 rounded-full"
                  />
                  <span className="text-white">{friend.full_name}</span>
                </div>
                {/* <button
                  onClick={() => handleFriendAction(friend)}
                  className={` rounded-md h-6 w-20 ${userProfile.friends.includes(friend.email) ? 'bg-red-500' : 'bg-green-500'} text-white`}
                >
                  {userProfile.friends.includes(friend.email) ? 'Remove' : 'Add'}
                  
                </button> */}
                <button
                  onClick={() => handleFriendAction(friend)}
                  className={`rounded-md h-6 w-20 text-xs text-white ${friend.alreadyRequested && "text-black"}  ${
                    userProfile.friends.includes(friend.email)
                      ? 'bg-red-500' // Remove friend style
                      : friend.alreadyRequested
                      ? 'bg-gray-500 text-black' // Requested style
                      : friend.requestedMe
                      ? 'bg-green-500' // Requested me style
                      : 'bg-green-500' // Add friend style
                  }`}
                >
                  {userProfile.friends.includes(friend.email)
                    ? 'Remove' // Friend already added
                    : friend.alreadyRequested
                    ? 'Requested' // Already sent request
                    : friend.requestedMe
                    ? 'Accept' // Request received
                    : 'Add' // Default to adding friend
                  }
                </button>


              </div>
            ))}
          </div>
        </div>
  )
}

export default FriendsList